module.exports = __webpack_public_path__ + "static/media/uber.8a2f39c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/assets/uber.png
// module id = 524
// module chunks = 0